/** Yup Validator that checks if a string contains another. In this scenario it's used to check
 * that email "test@ŧest.com"is found in "test@etest.com, test2@test.com" => true.
 * "test1@test.com, test2@test.com" => false
 * @param {*} largeStr The whole string
 * @param {*} message The message to show if the string is found
 */
export function isStringFoundInString(largeStr, message) {
  return this.test({
    name: 'equalTo',
    exclusive: false,
    message: message,
    test: function test(value) {
      if (largeStr.includes(value)) {
        return false;
      }

      return true;
    }
  });
}
export default {};